import React from "react";
import classnames from "classnames";

import SmartLink from "../../common/components/SmartLink";

import "./navTile.scss";

interface NavTileProps extends React.HTMLProps<HTMLDivElement> {
  action: string,
  label: string,
  isActive?: boolean,
  image?: string,
}

const NavTile: React.FC<NavTileProps> = ({
  action,
  label,
  isActive,
  image,
}) => {

  return (
    <SmartLink
      url={action}
      className={classnames({
        "d-block position-relative box-shadow-2 fs-9 tile-gradient-1 rounded-xs-2 rounded-md-3 overflow-hidden": true,
        "o-tile": true,
        "o-tile--active": isActive,
        "o-tile--inactive": !isActive,
      })}>
      {/* Image */}
      {image && (
        <span
          className={classnames({
            "o-tile__image": true,
            "o-tile__image--active": isActive,
            "o-tile__image--inactive": !isActive,
          })}
          style={{ backgroundImage: `url(${image})` }}>
        </span>)}
      {/* Text */}
      <span
        title={label}
        className={classnames({
          "flex-grow-1 px-2 py-1 text-center text-white text-uppercase": true,
          "o-tile__label": true,
          "o-tile__label--active": isActive,
          "o-tile__label--inactive": !isActive,
        })}>
        {label}
      </span>
    </SmartLink>
  );
}

export default NavTile;
